/**
 * External links for sign-in page actions. Both target mykoptnb-nextjs-backend.
 *
 * The values are inlined into the Vite bundle at build time
 * (see packages/experience/vite.config.ts), so changing them at runtime has no
 * effect — you must rebuild the Docker image.
 *
 * The `backUrl` query value must be present in the backend's
 * NEXT_PUBLIC_ALLOWED_BACK_URLS allowlist, otherwise the post-reset redirect
 * silently falls back to the backend's `/login` page.
 *
 * Set these as Docker build args:
 *   --build-arg reset_password_url=https://api.mykoptnb.com/forgot-password?backUrl=https://kopsys-beta.my/auth/login
 *   --build-arg first_time_login_url=https://api.mykoptnb.com/first-time-login?backUrl=https://kopsys-beta.my/auth/login
 */

export const resetPasswordUrl =
  process.env.RESET_PASSWORD_URL ??
  'https://app.mykoptnb.com/forgot-password?backUrl=https://ikop.mykoptnb.com/auth/login';

export const firstTimeLoginUrl =
  process.env.FIRST_TIME_LOGIN_URL ??
  'https://app.mykoptnb.com/first-time-login?backUrl=https://ikop.mykoptnb.com/auth/login';
